import AssetSettings from './AssetSettings';

export default AssetSettings;
